// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// custom components
import NumberedHeading from "../../../../../shared-components/forms/NumberedHeading";
import SummaryStatementSetArray from '../shared/SummaryStatementSetArray';
import ContentMaterialsArray from '../shared/ContentMaterialsArray';
import EmentorArray from '../shared/EmentorArray';

const RegisterAnalysis = (props) => {
  const { control, formState } = props.methods;
  const { errors } = formState;
  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Materials" instructions='Using the controls below, please add as many Materials as necessary for the activity' />
      <Controller
        control={control}
        name="content.materials"
        render={({ field }) => <ContentMaterialsArray inputDir={inputDir} {...{ control, errors }} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="2" title="Summary" instructions="Enter the summary." />
      <Controller
        control={control}
        name="content.summary"
        render={({ field }) => (
          <>
            <TextField
              {...field}
              className="mt-16 mb-16"
              label="Text"
              placeholder="Text"
              error={!!errors.content?.summary}
              helperText={errors.content?.summary?.message}
              fullWidth
              multiline
              minRows={1}
              maxRows={5}
              required
              dir={inputDir}
            />
          </>
        )}
      /> 

      <Divider className="mt-16" />

      <NumberedHeading number="3" title="Is Informal" instructions="Is this Summary meant to be informal?" />
      <Controller
        control={control}
        name='content.is_informal'
        render={({ field }) => (
          <FormControlLabel
            control={
              <Checkbox 
                onChange={(ev) => {
                  field.onChange(ev.target.checked);
                }}
                checked={field.value}
              />
            }
            label='Is Informal'
          />
        )}
      />

      <Divider className="mt-16" />

      <NumberedHeading number="4" title="Statement Sets" instructions='Using the controls below, please add as many Statement Sets as necessary for the activity' />
      <Controller
        control={control}
        name="content.statement_sets"
        render={({ field }) => <SummaryStatementSetArray inputDir={inputDir} {...{ control, errors }} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="5" title="eMentor Notes" instructions="Using the controls below, add any supplemental content to this page" />
      <Controller
        control={control}
        name="content.eMentor"
        render={({ field }) => <EmentorArray {...{ control, errors }} />}
      />
    </div>
  );
};

export default RegisterAnalysis;